import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class December2019 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='December2019'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/december2019/dd_decfi2019_landingpage.jpg" alt="Diamonds Direct December Financing" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/december2019/dd_decfi2019_landingpage_mobile.jpg" alt="Diamonds Direct December Financing" />
				<a href='tel:8004315921'>
					<div className='phoneLinkOverlay'></div>
				</a>
			</div>
			<div className="promoBody">

				<div className='bodyWrapper'>
					<div className="promoText">
						Let your love shine bright this holiday season with our exclusive December financing event.
					</div>
					<div className='promoActionBox'>
						<div className='boxTitle'>0% APR for 36 Months*</div>
						<div className='boxDisclaimer'>Subject to credit approval.</div>
						<div className='boxDates'>Available Dec. 1-31</div>
						<div className='boxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>*Learn More &amp; Apply</div>
						<div className='boxDisclaimer2'>Special financing cannot be combined with other discounts or offers. See representative for details.</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default December2019;

function mapStateToProps(state) {
  return {

  };
}

export const December2019Container = connect(
  mapStateToProps,
  allActionCreators
)(December2019);


// WEBPACK FOOTER //
// ./src/components/views/promopages/december2019/December2019.jsx